import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';

// "Next case study" strip for the foot of a case study page (internal linking).
export function CaseStudyNav({ to, title, client }) {
  return (
    <section className="cs-section cs-next-section" data-testid="cs-next-section">
      <div className="cs-container">
        <Link to={to} className="cs-next" data-testid="cs-next-link">
          <div className="cs-next-text">
            <span className="cs-next-kicker">Next case study</span>
            <h3 className="cs-next-title">{title}</h3>
            {client && <span className="cs-next-client">{client}</span>}
          </div>
          <span className="cs-next-arrow"><ArrowRight size={26} /></span>
        </Link>
        <Link to="/work" className="cs-next-all" data-testid="cs-all-work-link">
          View all work <ArrowUpRight size={16} />
        </Link>
      </div>
    </section>
  );
}
